import React from 'react'

import DisplayHomeBuilders from '../components/builder/DisplayHomeBuilders'
import CondoResults from '../components/condo/CondoResults'
import { MiniCondoBuilderResults } from '../components/MiniCondoBuilderReport'
import LgyPagination from 'app/components/util/lgy-pagination/LgyPagination'

const CondoBuilderResults = ({ minMode, whichReport, condoReport, homeBuilder, pageOfItems, onPageChange, handleReset }) =>
  <div className='condo-builder-results'>
    {minMode ?
      <MiniCondoBuilderResults
        whichReport={whichReport}
        list={whichReport === 'Condo' ? condoReport.list : homeBuilder.list}
        handleNewSearch={handleReset} />
      : whichReport === 'Condo' ?
        <CondoResults condoList={pageOfItems} totalListLength={condoReport.list.length} handleNewSearch={handleReset} />
        : <DisplayHomeBuilders pageResults={pageOfItems} totalListLength={homeBuilder.list.length} handleNewSearch={handleReset} />}
    {!minMode && <LgyPagination items={whichReport === 'Condo' ? condoReport.list : homeBuilder.list} onPageChange={onPageChange} />}
  </div>

export default CondoBuilderResults